import {
    BuildingSubPremiseType,
    type BuildingSubPremiseType as BuildingSubPremiseTypeValue,
} from '../../core-models';

export const BuildingSubPremiseTypeName: Record<
    BuildingSubPremiseTypeValue,
    string
> = {
    [BuildingSubPremiseType.Unknown]: 'Unknown',
    [BuildingSubPremiseType.Antenna]: 'Antenna',
    [BuildingSubPremiseType.Apartment]: 'Apartment',
    [BuildingSubPremiseType.AutomatedTellerMachine]: 'Automated teller machine',
    [BuildingSubPremiseType.Barbecue]: 'Barbecue',
    [BuildingSubPremiseType.Block]: 'Block',
    [BuildingSubPremiseType.Boatshed]: 'Boatshed',
    [BuildingSubPremiseType.Building]: 'Building',
    [BuildingSubPremiseType.Bungalow]: 'Bungalow',
    [BuildingSubPremiseType.Cage]: 'Cage',
    [BuildingSubPremiseType.Carpark]: 'Carpark',
    [BuildingSubPremiseType.Carspace]: 'Carspace',
    [BuildingSubPremiseType.Club]: 'Club',
    [BuildingSubPremiseType.Coolroom]: 'Coolroom',
    [BuildingSubPremiseType.Cottage]: 'Cottage',
    [BuildingSubPremiseType.Duplex]: 'Duplex',
    [BuildingSubPremiseType.Flat]: 'Flat',
    [BuildingSubPremiseType.Factory]: 'Factory',
    [BuildingSubPremiseType.Garage]: 'Garage',
    [BuildingSubPremiseType.Hall]: 'Hall',
    [BuildingSubPremiseType.House]: 'House',
    [BuildingSubPremiseType.Kiosk]: 'Kiosk',
    [BuildingSubPremiseType.Lobby]: 'Lobby',
    [BuildingSubPremiseType.Loft]: 'Loft',
    [BuildingSubPremiseType.Lot]: 'Lot',
    [BuildingSubPremiseType.Office]: 'Office',
    [BuildingSubPremiseType.Penthouse]: 'Penthouse',
    [BuildingSubPremiseType.Rear]: 'Rear',
    [BuildingSubPremiseType.Room]: 'Room',
    [BuildingSubPremiseType.Reserve]: 'Reserve',
    [BuildingSubPremiseType.Suite]: 'Suite',
    [BuildingSubPremiseType.Section]: 'Section',
    [BuildingSubPremiseType.Shed]: 'Shed',
    [BuildingSubPremiseType.Shop]: 'Shop',
    [BuildingSubPremiseType.Showroom]: 'Showroom',
    [BuildingSubPremiseType.Sign]: 'Sign',
    [BuildingSubPremiseType.Site]: 'Site',
    [BuildingSubPremiseType.Stall]: 'Stall',
    [BuildingSubPremiseType.Store]: 'Store',
    [BuildingSubPremiseType.Studio]: 'Studio',
    [BuildingSubPremiseType.StrataUnit]: 'Strata unit',
    [BuildingSubPremiseType.Substation]: 'Substation',
    [BuildingSubPremiseType.Tenancy]: 'Tenancy',
    [BuildingSubPremiseType.Townhouse]: 'Townhouse',
    [BuildingSubPremiseType.Tower]: 'Tower',
    [BuildingSubPremiseType.Unit]: 'Unit',
    [BuildingSubPremiseType.Villa]: 'Villa',
    [BuildingSubPremiseType.Vault]: 'Vault',
    [BuildingSubPremiseType.Ward]: 'Ward',
    [BuildingSubPremiseType.Lease]: 'Lease',
    [BuildingSubPremiseType.MarineBerth]: 'Marine berth',
    [BuildingSubPremiseType.Maisonette]: 'Maisonette',
    [BuildingSubPremiseType.Warehouse]: 'Warehouse',
    [BuildingSubPremiseType.Workshop]: 'Workshop',
};

export function getBuildingSubPremiseTypeName(
    type: BuildingSubPremiseTypeValue
): string {
    return (
        BuildingSubPremiseTypeName[type] ??
        BuildingSubPremiseTypeName[BuildingSubPremiseType.Unknown]
    );
}
